import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { OrderController, OrderEntity, OrderStatusEnum } from '@domain';
import { debounceTime } from 'rxjs';
import { RaEmptyComponent } from '../ra-empty/ra-empty.component';
import { RaFilletComponent } from '../ra-fillet/ra-fillet.component';
import { RaInputComponent } from '../ra-input/ra-input.component';
import { RaLoadingComponent } from '../ra-loading/ra-loading.component';
import { RaModalComponent } from '../ra-modal/ra-modal.component';

/**
 * Modal de busca/seleção de um serviço (order) em andamento — usado hoje pra
 * escolher o destino de "mover documento", mas genérico o suficiente pra
 * qualquer fluxo que precise escolher um order da empresa atual.
 */
@Component({
    selector: 'ra-modal-list-orders',
    templateUrl: 'ra-modal-list-orders.component.html',
    styleUrl: 'ra-modal-list-orders.component.scss',
    imports: [
        ReactiveFormsModule,
        RaModalComponent,
        RaLoadingComponent,
        RaEmptyComponent,
        RaInputComponent,
        RaFilletComponent,
        TranslatePipe,
    ],
})
export class RaModalListOrdersComponent implements OnInit {
    public message = input<string>();
    /** Order a excluir da lista (ex.: o order atual do documento, que não faz sentido como destino). */
    public excludeOrderId = input<string>();
    public close = output();
    public selectOrder = output<OrderEntity>();
    public loading = signal(true);
    public orders = signal<OrderEntity[]>([]);
    public searchControl = new FormControl('');

    // * [Injects]
    private _orderController = inject(OrderController);

    ngOnInit(): void {
        this._getOrders();
        this._listenSearchControl();
    }

    private _getOrders(search?: string): void {
        this.loading.set(true);
        this._orderController
            .getByFilter(OrderStatusEnum.PROGRESS, { page: 1, limit: 50 }, search)
            .subscribe({
                next: paginated => {
                    const orders = (paginated.data ?? []).filter(
                        order => order._id !== this.excludeOrderId()
                    );
                    this.orders.set(orders);
                    this.loading.set(false);
                },
                error: () => this.loading.set(false),
            });
    }

    private _listenSearchControl(): void {
        this.searchControl.valueChanges
            .pipe(debounceTime(600))
            .subscribe(value => this._getOrders(value ?? undefined));
    }
}
